import { RootState } from '../../Store';

import { useSelector } from 'react-redux';
import { AppState } from '../../Store/App/state';

const useGetSidebarIsOpened = (): boolean => {
    const { sidebarOpened } = useSelector<RootState, AppState>(state => state.app);
    return sidebarOpened;
};

export default useGetSidebarIsOpened;
